import { makeStyles } from '@material-ui/core/styles'

import { ChatMode } from '../../core/types/chat.types'
import useMaxAttachmentStore, {
  hasStagedAttachments,
} from '../../stores/use-max-attachment-store'
import AttachmentStagingArea from './attachment-staging-area'
import MessageInput from './message-input'

type ChatComposerProps = {
  mode: ChatMode
  textDisabled?: boolean
  attachmentsDisabled?: boolean
  helperMessage?: string
  preserveStagedAttachmentsWhenDisabled?: boolean
  onSend: (content: string) => void
  onAttachFiles: (files: FileList | File[]) => void
}

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1.5),
  },
}))

const ChatComposer = ({
  mode,
  textDisabled = false,
  attachmentsDisabled = false,
  helperMessage,
  preserveStagedAttachmentsWhenDisabled = false,
  onSend,
  onAttachFiles,
}: ChatComposerProps) => {
  const classes = useStyles()

  const attachments = useMaxAttachmentStore((state) => state.attachments)
  const attachmentError = useMaxAttachmentStore((state) => state.error)
  const removeAttachment = useMaxAttachmentStore((state) => state.removeAttachment)

  const showStagingArea = !attachmentsDisabled && (hasStagedAttachments(attachments) || Boolean(attachmentError))

  return (
    <div className={classes.root}>
      {showStagingArea && (
        <AttachmentStagingArea
          attachments={attachments}
          error={attachmentError}
          maxRows={4}
          onRemove={removeAttachment}
        />
      )}
      <MessageInput
        mode={mode}
        textDisabled={textDisabled}
        attachmentsDisabled={attachmentsDisabled}
        helperMessage={helperMessage}
        preserveStagedAttachmentsWhenDisabled={preserveStagedAttachmentsWhenDisabled}
        onSend={onSend}
        onAttachFiles={onAttachFiles}
      />
    </div>
  )
}

export default ChatComposer
